import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { appRepo } from "../../repo/app-repo.ts";
import AdminPageTitle from "../admin-pages/admin-page-title.tsx";
import { AppContext } from "../../context/app-context.tsx";
import AppVersionFormFields, {
  emptyAppVersionForm,
  isAppVersionFormValid,
  toAppVersionPayload,
} from "./app-version-form-fields.tsx";

export default function NewAppVersion() {
  const navigate = useNavigate();
  const { setMessage } = useContext(AppContext);
  const [form, setForm] = useState(emptyAppVersionForm);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onChange = (field: keyof typeof form, value: string | boolean) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!isAppVersionFormValid(form)) {
      setMessage({ type: "error", message: "لطفاً همه فیلدها را کامل کنید." });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await appRepo.createAppVersion(toAppVersionPayload(form));
      if (!response.status) {
        setMessage({ type: "error", message: response.message || "ایجاد نسخه ناموفق بود." });
        return;
      }

      setMessage({ type: "success", message: "نسخه با موفقیت ایجاد شد." });
      navigate("/admin/app-versions");
    } catch {
      setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="space-y-4">
      <AdminPageTitle title="ایجاد نسخه اپ" />
      <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6">
        <form onSubmit={onSubmit} className="grid gap-4 md:grid-cols-2">
          <AppVersionFormFields form={form} onChange={onChange} />
          <div className="flex items-center gap-3 md:col-span-2">
            <button
              type="submit"
              disabled={!isAppVersionFormValid(form) || isSubmitting}
              className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isSubmitting ? "در حال ایجاد…" : "ایجاد نسخه"}
            </button>
            <Link
              to="/admin/app-versions"
              className="inline-flex rounded-lg border border-slate-700 px-4 py-2 text-sm text-slate-200 transition hover:border-indigo-400 hover:text-indigo-300"
            >
              انصراف
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
}
